import { ItemType } from 'antd/lib/menu/hooks/useItems'
import { useProjectContext } from '../../../../context/ProjectContext'
import CIMSLink from '../../../../components/CIMSLink'
import { pathify } from '@cims-online/shared'

export function useWorkflows(): ItemType[] {
  const { projectId, workflows } = useProjectContext()
  return workflows.map(({ id, label, customizeRecordsLabel }) => ({
    key: id,
    label,
    children: [
      {
        label: (
          <CIMSLink to={pathify(projectId, 'workflows', id, 'records')}>
            {customizeRecordsLabel?.enabled
              ? customizeRecordsLabel?.label
              : 'Records'}
          </CIMSLink>
        ),
        key: `${id}-records`,
      },
      // This page will be implemented post MVP when we add actual edit controls.
      // {
      //   label: (
      //     <CIMSLink to={pathify(projectId, 'workflows', id, 'settings')}>
      //       Workflow Settings
      //     </CIMSLink>
      //   ),
      //   key: `${id}-settings`,
      // },
      // This page will be implemented post MVP when we add actual edit controls.
      // {
      //   label: (
      //     <CIMSLink to={pathify(projectId, 'workflows', id, 'statuses')}>
      //       Statuses
      //     </CIMSLink>
      //   ),
      //   key: `${id}-statuses`,
      // },
      {
        label: (
          <CIMSLink to={pathify(projectId, 'workflows', id, 'fields')}>
            Fields
          </CIMSLink>
        ),
        key: `${id}-fields`,
      },
      // This page will be implemented post MVP when we add actual edit controls.
      // {
      //   label: (
      //     <CIMSLink to={pathify(projectId, 'workflows', id, 'plugins')}>
      //       Plugins
      //     </CIMSLink>
      //   ),
      //   key: `${id}-plugins`,
      // },
      {
        label: (
          <CIMSLink to={pathify(projectId, 'workflows', id, 'notifications')}>
            Notifications
          </CIMSLink>
        ),
        key: `${id}-notifications`,
      },
      {
        label: (
          <CIMSLink to={pathify(projectId, 'workflows', id, 'permissions')}>
            Permissions
          </CIMSLink>
        ),
        key: `${id}-permissions`,
      },
    ],
  }))
}
